// eslint-disable-next-line no-useless-escape
export const regex_email = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/);

export const regex_password = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/);

export const regex_dateFormat = /^(0?[1-9]|[12]\d|3[01])\/(0?[1-9]|1[0-2])\/((19|20)\d\d)$/;

export const regex_domainUrlOnly = /^https:\/\/([a-z0-9-]+(?:\.[a-z0-9-]+)*)\.([a-z]{2,})$/i;

export const regex_phone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
